import { render, staticRenderFns } from "./createPackageOrder2.vue?vue&type=template&id=4bbdf0ed&scoped=true"
import script from "./createPackageOrder2.vue?vue&type=script&lang=js"
export * from "./createPackageOrder2.vue?vue&type=script&lang=js"
import style0 from "./createPackageOrder2.vue?vue&type=style&index=0&id=4bbdf0ed&prod&scoped=true&lang=css"
import style1 from "./createPackageOrder2.vue?vue&type=style&index=1&id=4bbdf0ed&prod&lang=css"
import style2 from "./createPackageOrder2.vue?vue&type=style&index=2&id=4bbdf0ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbdf0ed",
  null
  
)

export default component.exports